import { MDBIcon } from "mdb-react-ui-kit";
import PropTypes from "prop-types";

export default function Star( { hover, isSelected, onClick, onMouseEnter, onMouseLeave } ) {
    return (
        <span
            style={ {
                marginRight: "3px",
                color: isSelected ? "#09B4BF" : hover ? "#09B4BF" : "#e4e5e9",
                cursor: "pointer",
            } }
            onMouseEnter={ onMouseEnter }
            onMouseLeave={ onMouseLeave }
            onClick={ onClick }
            role="button"
        >
      <MDBIcon fas icon="window-minimize" size="xs"/>
    </span>
    );
};

Star.propTypes = {
    isSelected: PropTypes.bool,
    hover: PropTypes.bool,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
}
